var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "#ffffff"
    },
    className: "cs-ico-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M17.9,7.1C16.7,6.8,12,6.8,12,6.8s-4.7,0-5.9,0.3C5.5,7.2,5,7.8,4.8,8.4C4.5,9.6,4.5,12,4.5,12s0,2.4,0.3,3.6     c0.2,0.6,0.7,1.1,1.3,1.3c1.2,0.3,5.9,0.3,5.9,0.3s4.7,0,5.9-0.3c0.6-0.2,1.1-0.7,1.3-1.3c0.3-1.2,0.3-3.6,0.3-3.6s0-2.4-0.3-3.6     C19,7.8,18.5,7.2,17.9,7.1z M10.5,14.2V9.8l3.9,2.2L10.5,14.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "10.5,14.2 14.4,12 10.5,9.8   "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M19.5,12c0,0,0,2.4-0.3,3.6c-0.2,0.6-0.7,1.1-1.3,1.3       c-1.2,0.3-5.9,0.3-5.9,0.3s-4.7,0-5.9-0.3c-0.6-0.2-1.1-0.7-1.3-1.3C4.5,14.4,4.5,12,4.5,12s0-2.4,0.3-3.6C5,7.8,5.5,7.2,6.1,7.1       C7.3,6.8,12,6.8,12,6.8s4.7,0,5.9,0.3c0.6,0.2,1.1,0.7,1.3,1.3C19.5,9.6,19.5,12,19.5,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/YoutubeIcon.da15aa8315f80fa6cf57466b69f4fc8c.svg";
export { ForwardRef as ReactComponent };